"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var hasWarnAboutTypo = !1;
function getPartialVisibilityGutter(responsive, partialVisible, serverSideDeviceType, clientSideDeviceType) {
  var gutter = 0,
    deviceType = clientSideDeviceType || serverSideDeviceType;
  return partialVisible && deviceType && (!hasWarnAboutTypo && "production" !== process.env.NODE_ENV && responsive[deviceType].paritialVisibilityGutter && (hasWarnAboutTypo = !0, console.warn("You appear to be using paritialVisibilityGutter instead of partialVisibilityGutter which will be moved to partialVisibilityGutter in the future completely")), gutter = responsive[deviceType].partialVisibilityGutter || responsive[deviceType].paritialVisibilityGutter), gutter;
}
function getWidthFromDeviceType(deviceType, responsive) {
  var itemWidth;
  responsive[deviceType] && (itemWidth = (100 / responsive[deviceType].items).toFixed(1));
  return itemWidth;
}
function getItemClientSideWidth(props, slidesToShow, containerWidth) {
  return Math.round(containerWidth / (slidesToShow + (props.centerMode ? 1 : 0)));
}
exports.getPartialVisibilityGutter = getPartialVisibilityGutter, exports.getWidthFromDeviceType = getWidthFromDeviceType, exports.getItemClientSideWidth = getItemClientSideWidth;